/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// CHILDREN
import AnimatedCompletedEducationBadge from './AnimatedCompletedEducationBadge'

// ASSETS
import './CompletedEducation.scss'

class CompletedEducation extends Component {
  render() {
    const { education, closeCompleteModal, t } = this.props
    return (
      <div id='CompletedEducation'>
        <h2>{t('education.completed.congratulations', { name: education.name })}</h2>
        <AnimatedCompletedEducationBadge education={education} />
        <p>{t('education.completed.message')}</p>
        <button
          className='btn btn-primary'
          onClick={() => closeCompleteModal(education)}
        >
          <i className='fa fa-arrow-left' /> {t('education.completed.goBack')}
        </button>
      </div>
    )
  }
}

export default withTranslation()(CompletedEducation)
